@use '@lib/assets/styles/main.scss' as *;

.root {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  border-top: 1px solid $gray100;
  border-bottom: 1px solid $gray100;
  padding: 12px 16px;
}

.actionsRow {
  display: flex;
  align-items: center;
  gap: 16px;
}

.imageWrap {
  padding: 0 24px 24px;
  flex: auto 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image {
  display: block;
  margin: 0 auto;
}
